<div class="viewer-header">
  <ng-container *ngIf="this.terminal$ | async as terminal">
    <div class="container-fluid">
      <div class="row align-items-center h-100">
        <!-- Terminal Info -->
        <div class="col-md-3">
          <div class="d-flex align-items-center">
            @if (logo) {
              <img
                [src]="logo.imageUrl"
                [alt]="logo.name || 'Logo'"
                class="card-img-top"
                style="
                  height: 60px;
                  width: auto;
                  object-fit: cover;
                  padding: 1px;
                  border-radius: 2px;
                "
              />
            }

            <div class="terminal-name me-3 ms-2">
              {{ terminal.name }}
            </div>
            <div class="machine-status">
              <ng-container *ngIf="currentMachineStatus$ | async as status">
                <i
                  [style.color]="status.statusColor"
                  class="fas fa-circle status-indicator me-2"
                ></i>
                <span>{{ status.name }}</span>
              </ng-container>
            </div>
          </div>
        </div>

        <!-- Process Info -->
        <div class="col-md-6 text-center process-info">
          <ng-container *ngIf="terminal.currentProcessName">
            <span class="process-label">{{
              "LK.process.processName" | translate
            }}</span>
            {{ terminal.currentProcessName }}
          </ng-container>
        </div>

        <!-- Actions -->
        <div class="col-md-3">
          <div class="d-flex align-items-center justify-content-end">
            <button
              class="btn btn-outline-warning me-3"
              (click)="onClickToggleTranslation()"
            >
              <img
                [ngSrc]="currentLanguageFlagComputed()"
                alt=""
                height="16"
                width="16"
              />
            </button>
            <button
              class="btn btn-outline-warning me-3"
              (click)="openFeedbackModal()"
              [ngbTooltip]="'LK.header.reportIssue' | translate"
              placement="bottom"
            >
              <i class="fas fa-exclamation-triangle"></i>
            </button>
            <div class="date-display">
              {{ currentDate }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
